// ** React Imports
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

// ** Hooks Import
import { useAuth } from '../../../hooks/useAuth';

const AuthGuard = ({ children, fallback }) => {
  const auth = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Check if user is authenticated
    if (!localStorage.getItem('userData')) {
      const returnUrl = location.pathname !== '/' ? `?returnUrl=${location.pathname}` : '';
      navigate(`/login${returnUrl}`, { replace: true });
    }
  }, [location.pathname, navigate]);

  return <>{children}</>;
};

export default AuthGuard;
